import React, { useState, useEffect } from "react";
import "./planpagelayout.css";
import { useDispatch, useSelector } from "react-redux";
import axiosInHealth from "../../Redux/axios/AxiosInHealth";
import { QuickQuoteHealth,ErrQuotesHealth} from "../../Redux/actions/NumHealth";
import { 
  Button, 
  Form,
  Radio,
  message
} from 'antd/lib';
export default function PlanTypeHeath({setisModalPlanType}) {
    const dispatch = useDispatch();
    const Healthnum = useSelector((state) => state?.healthdetail?.healthnum);
    const QuickQuotes = useSelector((state) => state?.healthdetail?.quickquotes);
    const QuotePost = useSelector((state) => state?.healthdetail?.QuickQuotePost);
    const QuoteInput = useSelector((state) => state?.healthdetail?.quoteInput);
    const [loading, setLoading] = useState(false)

    const onChange = (e) => {
      console.log('radio checked', e.target.value);
      // setValue(e.target.value);
    };
    const onFinish = (values) => {
      console.log('product values',values)
      const UpdatePlan = {
        ...QuotePost,
        policyPeriod : values?.multiYear,
      }
      setLoading(true)
      // axiosInHealth
      //   .post(`v1/health_insurances/${Healthnum?.health_insurance_id}/quick_quotes`, UpdatePlan)
      //   .then((res) => {
      //     if (res.status === 200) {
      //       const Udata = res?.data?.data
      //       //console.log("data-----------------",data)
      //       const errData = Udata?.filter(item => ("status" in item && item.status === "failed"));
      //       dispatch(ErrQuotesHealth(errData));
      //       const filteredData = Udata?.filter(item => ("status" in item && item.status === "success"));
      //       const updatedData = filteredData?.map(item => ({
      //         ...item,
      //         selected: false
      //       }));
      //       console.log(updatedData)
      //       dispatch(QuickQuoteHealth(updatedData));
      //       setLoading(false)
      //       setisModalPlanType(false)
      //     }
      //   })
      //   .catch((err) => {
      //     console.log(err.response.data.error);
      //     setLoading(false)
      //     message.error(err.response.data.error);
      //   });
    }; 
  return (
    <>
       <Form
        onFinish={onFinish}
        layout="vertical"
        requiredMark={false}
        >
            <p className="border-bottom mb-0"
             style={{fontSize: "14px", paddingBottom:"10px"}}>Select a Plan Type.</p>
          <Form.Item
          name="product"
        // className="cvEditSec"
          rules={[
            {
              required: true,
              message: 'Please select Policy Type',
            },
          ]}
          initialValue={QuoteInput?.insuranceProductCode}
          >
            <Radio.Group
              className="py-3 px-3 pb-0 bg-white ant-radio-layout prev-prod-sec-health"
              onChange={onChange}
              >
                <Radio value="1">Arogya Sanjeevani</Radio>
                <Radio value="2">Global Plans</Radio>
                <Radio value="3">Base health</Radio>
                <Radio value="4">1 crore plan</Radio>
                <Radio value="5">TopUp plans</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item style={{textAlign: "center"}}>
                <Button type="primary" 
                htmlType="submit"
                className="update-qut-button"
                loading={loading}
                >Update</Button>
            </Form.Item>
        </Form>
    </>
  );
}
